import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const venues = [{
  id: 1,
  name: 'FOOD',
  subtitle: 'Dining & Brunch',
  description: 'The food Yeah… it slaps. 🔥 Experience our signature Dining and legendary Brunch. Jollof & Suya that hits every time.',
  hours: 'OPEN DAILY',
  href: '/dining',
  image: 'https://cdn.magicpatterns.com/uploads/s3K8wKdfybMP1zxoh7PS3W/SnapInsta.to_684049710_18095297510328170_549094879827346722_n.jpg',
  video: 'https://cdn.magicpatterns.com/uploads/kuV672Q45N7omdtkaA1srn/The food Yeah… it slaps. 🔥Don’t debate it — experience it.Jollof & Suya that hits every time.Th.mp4'
}, {
  id: 2,
  name: 'NIGHTLIFE',
  subtitle: 'Elite Entertainment',
  description: 'Never a dull night at the Theatre of Dreams. Check our nightlife schedules — beautiful weather, great vibes.',
  hours: '11PM - 3AM',
  href: '/nightlife',
  image: 'https://cdn.magicpatterns.com/uploads/ad6jT6urC8DptPHknEKxeE/SnapInsta.to_686901633_17925323268315122_4386797257290448497_n.jpg',
  video: 'https://cdn.magicpatterns.com/uploads/wieyszei4i4SLLp24zmkTw/Never a dull night at the Theatre of Dreams.Spring into the weekend with us — beautiful weather,.mp4'
}, {
  id: 3,
  name: 'PRIVATE EVENTS BOOKINGS',
  subtitle: 'Bespoke Affairs',
  description: 'Host your next event with us. From corporate mixers to private celebrations, we provide the ultimate venue booking experience.',
  hours: 'BOOK NOW',
  href: '/corporate-events',
  image: 'https://cdn.magicpatterns.com/uploads/va8WBqwRFPJVrp1Tyd8QNn/SnapInsta.to_684140561_18095297540328170_1227165002793297535_n.jpg',
  video: 'https://cdn.magicpatterns.com/uploads/gPaCg1KM1zYkh1fbYwJtok/AFRICA DAY BRUNCH WAS ONE FOR THE BOOKS 🔥🌍🥂Great food. Endless mimosas. Amazing energy w-  Mi.mp4'
}];
function VenueCard({
  venue,
  index
}: {
  venue: any;
  index: number;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.2
  }} className="group relative h-[400px] md:h-[500px] overflow-hidden cursor-pointer rounded-2xl" onClick={() => navigate(venue.href)} onMouseEnter={() => videoRef.current?.play()} onMouseLeave={() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }} data-id="element-791">
      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500 z-10" data-id="element-792" />

      {/* Video (visible by default, plays on hover) */}
      <video ref={videoRef} src={encodeURI(venue.video)} muted loop playsInline className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-793" />

      <div className="absolute inset-0 z-20 flex flex-col justify-end p-6 md:p-8" data-id="element-794">
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-1 tracking-wider" data-id="element-795">
          {venue.name}
        </h3>
        <p className="text-[#DDA247] text-xs md:text-sm font-medium tracking-widest uppercase mb-2 md:mb-3" data-id="element-796">
          {venue.subtitle}
        </p>
        <p className="text-gray-300 text-xs md:text-sm leading-relaxed mb-4 md:transform md:translate-y-4 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 transition-all duration-500" data-id="element-797">
          {venue.description}
        </p>
        <div className="flex items-center justify-between" data-id="element-798">
          <span className="text-[10px] md:text-xs text-gray-400 tracking-widest font-medium" data-id="element-799">
            {venue.hours}
          </span>
          <div className="flex items-center text-[#DDA247] font-medium tracking-widest text-xs md:text-sm uppercase group-hover:text-white transition-colors" data-id="element-800">
            Explore <ArrowRight className="ml-2 w-3 h-3 md:w-4 md:h-4" data-id="element-801" />
          </div>
        </div>
      </div>

      {/* Border effect */}
      <div className="absolute inset-3 md:inset-4 border border-white/20 z-20 pointer-events-none group-hover:border-[#DDA247]/50 transition-colors duration-500 rounded-xl" data-id="element-802" />
    </motion.div>;
}
export function VenueSection() {
  return <section id="venues" className="py-12 md:py-16 bg-[#0B1014] relative overflow-hidden" data-id="element-803">
      <div className="container mx-auto px-6" data-id="element-804">
        <div className="text-center mb-12 md:mb-16" data-id="element-805">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4 tracking-wide" data-id="element-806">
            THE ULTIMATE EXPERIENCE
          </motion.h2>
          <div className="w-16 md:w-24 h-1 bg-[#DDA247] mx-auto mb-4 md:mb-6" data-id="element-807" />
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-base md:text-lg text-gray-300 tracking-wide px-4 md:px-0" data-id="element-808">
            Three distinct worlds. One extraordinary destination.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-809">
          {venues.map((venue, index) => <VenueCard key={venue.id} venue={venue} index={index} data-id="element-810" />)}
        </div>
      </div>
    </section>;
}